import { render, staticRenderFns } from "./_FilterDetailDate.vue?vue&type=template&id=b897835c&"
import script from "./_FilterDetailDate.vue?vue&type=script&lang=js&"
export * from "./_FilterDetailDate.vue?vue&type=script&lang=js&"
import style0 from "./_FilterDetailDate.vue?vue&type=style&index=0&id=b897835c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports